export default __webpack_public_path__ + "static/media/image-placeholders.23d5329e.jpg";